import $ from 'jquery';
import BaseComponent from './baseComponent';

/**
 * Handle the orders by javascript, show and fill up the forms.
 */
export default class PublicationOrder extends BaseComponent {
  /**
     * Public constructor
     *
     * @param options
     */
  constructor(options) {
    super(options);

    this.elementDataName = 'publications-form';

    return this;
  }

  showOrderElements($form) { // eslint-disable-line class-methods-use-this
    $form.find('.hidden-publication').addClass('-show');
  }

  trackOrderInputs($form) { // eslint-disable-line class-methods-use-this
    const $inputs = $($form.find('.order-input'));

    // $(this.$forms.find('form')).find('input[type="submit"]')
    // .before('<textarea id="order_form_output" name="order_form_output"></textarea>');

    const $orderOutput = $($form.find('.vp-bank-base-order-element'));
    const allOutputs = {};

    $inputs.on('keyup', (event) => {
      const $formOutput = $($form.find('.order-output'));
      const $input = $(event.currentTarget);
      const id = $input.data('publication-id');
      const $idOutput = $formOutput.find(`#${id}`);
      const title = $(event.currentTarget).data('publication-title');
      const lang = $(event.currentTarget).data('publication-language');
      const { value } = event.currentTarget;

      $formOutput.find('.order-output-example').hide();

      if ($idOutput) {
        $idOutput.remove();
        if (allOutputs[id]) {
          delete allOutputs[id];
        }
      }

      let textOutput = '';

      if (value !== '') {
        if (parseInt(value, 10) < 1 || parseInt(value, 10) !== parseFloat(value, 10)) {
          $input.closest('.form-text').addClass('-error');
        } else {
          $input.closest('.form-text').removeClass('-error');

          allOutputs[id] = {};
          allOutputs[id].value = value;
          allOutputs[id].lang = lang;
          allOutputs[id].title = title;

          textOutput = `<div class="publication-order-item" id="${id}">`;
          textOutput += `<div class="title">${title}</div>`;
          textOutput += `<div class="value">${value}x</div>`;
          textOutput += `<div class="language">${lang}</div>`;
          textOutput += '</div>';
        }
      }

      $formOutput.append(textOutput);

      let orderOutput = '';

      $.each(allOutputs, (index, output) => {
        orderOutput += `${output.title}: ${output.value}x (${output.lang}); \n`;
      });

      $orderOutput.val(orderOutput);
    });
  }

  /**
     * Initialize function
     */
  init() {
    this.$forms = $(`[data-${this.elementDataName}]`);

    // show all hidden-elements (order is only available with javascript).
    $.each(this.$forms, (index, form) => {
      const $form = $(form);
      this.showOrderElements($form);
      this.trackOrderInputs($form);
    });
  }
}
